import reduxStore from 'redux/store'
import {setEzamowieniaOauth} from "../redux/actions";


function useEzamowieniaOauth() {
    const authorizeEzamowienia = (successCallback, errorCallback, requiredGroups) => {
        reduxStore.dispatch(setEzamowieniaOauth({successCallback, errorCallback, requiredGroups}));
    }
    return {authorizeEzamowienia}

}

export default useEzamowieniaOauth;